import ParentUser from './ParentUser';

export default class ChildParentRelation {

    static fromData(data) {
        if (!data) {
            return;
        }

        let relation = new ChildParentRelation();
        relation.id = data.id;
        relation.isParentAllowedForMoodBarometer = data.is_parent_allowed_for_mood_barometer;
        relation.isPrimaryContact = data.is_primary_contact;
        relation.parentUser = ParentUser.fromData(data.parentUser.data);

        return relation;
    }
}
